// hooks/useAtualizarDados.ts
import { useEffect, useState } from "react";
import { infoPagamentoAtivoService } from "../../../services/buscarInfoPagamentoAtivo";

export const useInfoPagamentoAtivo = (usuarioId: number) => {
  const [isLoading, setIsLoading] = useState(false);
  const [infoPagData, setInfoPagData] = useState<any>({});

  useEffect(() => {
    const fetch = async () => {
      if (usuarioId) {
        setIsLoading(true);
        try {
          const data = await infoPagamentoAtivoService(usuarioId);

          if (data) {
            setInfoPagData(data);
          } else {
            setInfoPagData(null);
          }
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetch();
  }, [usuarioId]);

  return { isLoading, infoPagData };
};
